var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineQuestionAnswerBigCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 20V30.5H21.755L20.87 31.385L20 32.255V20H36.5ZM38 17H18.5C17.675 17 17 17.675 17 18.5V39.5L23 33.5H38C38.825 33.5 39.5 32.825 39.5 32V18.5C39.5 17.675 38.825 17 38 17ZM45.5 23H42.5V36.5H23V39.5C23 40.325 23.675 41 24.5 41H41L47 47V24.5C47 23.675 46.325 23 45.5 23Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineQuestionAnswerBigCircle64Px);
export default __webpack_public_path__ + "static/media/ic_outline-question_answer_big_circle-64px.dc438c7683aeeb7310d22514bc1d9a52.svg";
export { ForwardRef as ReactComponent };